import { Controller } from "@hotwired/stimulus";
import { visitTrail } from "../visit_trail.js";

// Fills the hidden "page d'origine" fields of the contact form at submit time,
// once Turbo has recorded the contact page itself as the current visit.
export default class extends Controller {
  static targets = ["originPage", "landingPage", "externalReferrer"];

  fill() {
    const trail = visitTrail();
    const ref = new URLSearchParams(location.search).get("ref");
    const origin = trail.previous || "(direct)";

    this.originPageTarget.value = ref ? `${origin} (ref=${ref})` : origin;
    this.landingPageTarget.value = trail.landing || "";
    this.externalReferrerTarget.value = trail.referrer || "";
  }
}
